import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import locationIcon from "../../../images/locationIcon.png";

import CommonContactModal from "../../UserComponent/Profile/CommonContactModal";

import BasicDetailsIcon from "../../../images/Basic-Details-icon.svg";
import ContactIcon from "../../../images/contact-icon.svg";
import EducationIcon from "../../../images/education-icon.svg";
import jobIcon from "../../../images/briefcase-icon.svg";
import FamilyIcon from "../../../images/family-icon.svg";
import ReligionAstroIcon from "../../../images/religionastro-icon.svg";
import DietaryHabitsIcon from "../../../images/DietaryHabits.svg";
import DrinkHabitIcon from "../../../images/drinkHabit.svg";
import SmokingHabitIcon from "../../../images/smokingHabit.svg";
import HabitIcon from "../../../images/habit-icon.svg";
import HobbiesIcon from "../../../images/hobbies.svg";
import DoubleTick from "../../../images/double-tick.svg";
import HeartMale from "../../../images/blue-maleconnection-heart.svg";
import HeartFemale from "../../../images/pink-femaleconnection-heart.svg";

import GreenTick from "../../../images/greenCheckIcon.svg";
import RedCross from "../../../images/redCrossIcon.svg";

import BookmarkIcon from "../../../images/bookmark-icon.svg";
import BookmarkIconFilled from "../../../images/bookmarkIconFilled.svg";

import LifestyleIcon from "../../../images/healthy-lifestyle-icon.svg";
import starIcon from "../../../images/star-icon.svg";

import lastViewedIcon from "../../../images/lastViewedIcon.svg";

import crownIconPremium from "../../../images/crownIconPremium.svg";
import assistedVip from "../../../images/assistedVip.png";

import BlueVerified from "../../../images/BlueVerified.png";

import IsmallButton from "../../../images/IsmallButton.png";

import lockContact from "../../../images/lockContact.png";

import maleImg from "../../../images/Male-default-profile.png";
import femaleImg from "../../../images/female-default-profile.png";

import {
  Avatar,
  Box,
  Button,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { ActionButton } from "./ActionButton";
import { toast, ToastContainer } from "react-toastify";

import {
  getFullProfileByUsername,
  profileActivityJava,
  contactViewJava,
} from "../../../javaAxiosConfig";

import boyImg from "../../../images/blankPicBoy2.png";
import gitlImg from "../../../images/blankPic3.png";
import ShareIcon from "@mui/icons-material/Share"; // Import Share icon
import IconButton from "@mui/material/IconButton"; // Import IconButton
import axios from "axios";

import ViewPhotoIcon from "../../../images/view-photo-icon.svg";

const isValidValue = (val) =>
  val !== null && val !== undefined && String(val).trim() !== "";

const ProfileHeader = ({
  imageUrl,
  isPhotoVisible,
  imageBase64,
  photoCount,
  lastSeenText,
  lastViewedText,
  isShortlisted,
  userName,
  userId,

  handleViewPhotos,

  verifiedStatus,

  defaultImage,
  onToggleBookmark,
  membershipType,
  bookmarkAnimating,
}) => {
  const getProfileImage = () => {
    if (imageBase64) return imageBase64;
    if (imageUrl) return imageUrl;

    // SAME fallback logic as SliderComponent
    if (userId?.startsWith("M")) return maleImg;
    return femaleImg;
  };

  const [currentImage, setCurrentImage] = React.useState(null);

  React.useEffect(() => {
    setCurrentImage(getProfileImage());
  }, [imageUrl, imageBase64]);

  return (
    <div
      style={{
        width: "100%",
        height: "374px",
        position: "relative",
        borderRadius: "20px",
        overflow: "hidden",
        fontFamily: "Montserrat",
      }}
    >
      {/* ===== BLURRED BACKGROUND IMAGE ===== */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          // backgroundImage: `url("${getProfileImage()}")`,
          backgroundImage: `url("${currentImage || defaultImage}")`,

          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          filter: "blur(23px)",
          transform: "scale(1.1)",
        }}
      />

      {/* ===== FOREGROUND IMAGE (ASPECT SAFE) ===== */}
      <img
        src={currentImage || defaultImage}
        alt=""
        onError={() => {
          setCurrentImage(defaultImage);
        }}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          right: "0",
          margin: "auto",
          height: "336px",
          maxWidth: "100%",
          objectFit: "contain", // 🔥 CRITICAL
        }}
      />

      {/* ================= DARK GRADIENT OVERLAY ================= */}
      <div
        style={{
          position: "absolute",
          bottom: "53px",
          left: 0,
          width: "100%",
          height: "100px",
          background:
            "linear-gradient(184deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0.6) 100%, rgba(0,0,0,0.42) 100%)",
        }}
      />

      {/* ================= ONLINE STATUS LAST SEEN ================= */}

      {lastSeenText && (
        <div
          style={{
            position: "absolute",
            top: "35px",
            left: "0px",
            display: "flex",
            alignItems: "center",
            background: "#FFF",
            height: "24px",
            padding: "0 10px",
            borderRadius: "0px 5px 5px 0px",
            fontSize: "10px",
            fontWeight: 500,
            zIndex: 10,
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              // background: "rgba(230,0,0,0.81)",
              background:
                lastSeenText?.toLowerCase() === "online"
                  ? "green"
                  : "rgba(230, 96, 0, 0.71)",
              marginRight: "6px",
            }}
          />
          {lastSeenText}
        </div>
      )}

      {/* ================= PREMIUM / ASSISTED BADGE ================= */}
      {["Premium", "Premium+", "Assisted"].includes(membershipType) && (
        <div
          style={{
            position: "absolute",
            top: "23px",
            right: "1px",
            display: "flex",
            alignItems: "center",
            background: "#FFF",
            borderRadius: "50px 0 0 50px",
            border: "1px solid rgba(255,119,5,0.88)",
            height: "33px",
            padding: "0 12px 0 3px",
            zIndex: 10,
          }}
        >
          <img
            src={membershipType === "Assisted" ? assistedVip : crownIconPremium}
            alt="membership"
            style={{ width: "27px", height: "27px" }}
          />
          <span
            style={{ marginLeft: "6px", fontSize: "11px", fontWeight: 600 }}
          >
            {membershipType}
          </span>
        </div>
      )}

      {/* ================= RIGHT SIDE ICONS ================= */}

      <div
        style={{
          position: "absolute",
          top: "200px",
          right: "25px",
          width: "36px",
          height: "36px",
          background: "#FFF",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10,
          cursor: "pointer",

          transform: bookmarkAnimating ? "scale(1.2)" : "scale(1)",
          transition: "transform 0.2s ease",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onToggleBookmark(); // ✅ delegate to parent
        }}
      >
        <img
          src={isShortlisted ? BookmarkIconFilled : BookmarkIcon}
          alt="Bookmark"
          width="18"
          height="18"
        />
      </div>

      <div
        // onClick={handleViewPhotos}
        onClick={(e) => {
          e.stopPropagation();
          handleViewPhotos();
        }}
        style={{
          position: "absolute",
          top: "248px",
          right: "25px",
          width: "35px",
          height: "35px",
          background: "#FFF",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10,
        }}
      >
        <img src={ViewPhotoIcon} alt="" width="18" />
        <div
          style={{
            position: "absolute",
            top: "-4px",
            right: "-4px",
            width: "15px",
            height: "15px",
            borderRadius: "50%",
            background: "#ffffff",
            color: "#E60000",
            fontSize: "9px",
            fontWeight: 600,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.30)",
          }}
        >
          {photoCount || 0}
        </div>
      </div>

      {/* ================= USER ID ================= */}
      <div
        style={{
          position: "absolute",
          top: "227px",
          left: "48px",
          fontSize: "20px",
          fontWeight: 500,
          color: "#ffffff",
        }}
      >
        {userId}
      </div>

      {/* ================= USER NAME ================= */}
      <div
        style={{
          position: "absolute",
          top: "259px",
          left: "48px",
          fontSize: "30px",
          fontWeight: 600,
          color: "#FFF",
        }}
      >
        {userName}
      </div>

      {/* ================= BOTTOM WHITE STRIP ================= */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "55px",
          background: "#FFF",
          borderTop: "1px solid #D4D4D4",
        }}
      />

      {/* ================= PROFILE VERIFIED (BLUE RIBBON) ================= */}
      {verifiedStatus && (
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            left: "30px",
            display: "flex",
            alignItems: "center",
            padding: "7px 65px 7px 14px",
            background: "linear-gradient(90deg, #fefeff 0%, #bddaf6 100%)",
            borderRadius: "0 30px 30px 0",
            boxShadow: "0px 6px 14px rgba(0,0,0,0.22)",
            clipPath: "polygon(0 0, 85% 0, 75% 50%, 85% 100%, 0 100%)",
            zIndex: 10,
          }}
        >
          <img
            src={BlueVerified}
            alt="verified"
            width="20"
            style={{ marginRight: "10px" }}
          />

          <span
            style={{
              fontSize: "12px",
              fontWeight: 700,
              color: "#1E88E5",
              marginRight: "5px",
              whiteSpace: "nowrap",
            }}
          >
            Profile Verified
          </span>

          <img src={IsmallButton} width="12" alt="info" />
        </div>
      )}

      {/* ================= LAST VIEWED ================= */}
      {lastViewedText && (
        <div
          style={{
            position: "absolute",
            bottom: "18px",
            right: "30px",
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: 500,
            color: "#525151",
          }}
        >
          <img src={lastViewedIcon} width="15" alt="" />
          <span style={{ marginLeft: "6px" }}>
            Last Viewed : {lastViewedText}
          </span>
        </div>
      )}
    </div>
  );
};

const DetailRow = ({ label, value, rightAction = null }) => {
  if (value === null || value === undefined || value === "" || value === "--")
    return null;

  return (
    <>
      <div className="detail-row">
        <div className="detail-label">{label}</div>

        <div className="detail-value">
          <span>{value}</span>
          {rightAction}
        </div>
      </div>

      <style>
        {`
        .detail-row {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 600;
          color: #4f4f4f;
          flex-wrap: wrap;
        }

        .detail-label {
          flex: 0 0 210px;
        }

        .detail-value {
          display: flex;
          align-items: center;
          gap: 12px;
          color: #000;
          flex: 1;
          flex-wrap: wrap;
          word-break: break-word;
        }

        /* Tablet */
        @media (max-width: 768px) {
          .detail-label {
            flex: 0 0 160px;
            font-size: 14px;
          }

          .detail-value {
            font-size: 14px;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .detail-label {
            flex: 0 0 130px;
            font-size: 13px;
          }

          .detail-value {
            font-size: 13px;
          }
        }

        /* Very Small (320px) */
        @media (max-width: 360px) {
          .detail-label {
            flex: 0 0 110px;
            font-size: 12px;
          }

          .detail-value {
            font-size: 12px;
          }
        }
        `}
      </style>
    </>
  );
};

const PreferenceRow = ({ label, value, match }) => {
  if (!value) return null;

  return (
    <>
      <div className="pref-row">
        <img
          src={match === "Yes" ? GreenTick : RedCross}
          alt="status"
          className="pref-icon"
        />

        <div className="pref-label">{label}</div>

        <div className="pref-value">{value}</div>
      </div>

      <style>
        {`
        .pref-row {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 10px 0;
          flex-wrap: wrap;
        }

        .pref-icon {
          width: 18px;
          height: 18px;
          flex-shrink: 0;
        }

        .pref-label {
          flex: 0 0 200px;
          font-weight: 600;
          color: #4F4F4F;
        }

        .pref-value {
          flex: 1;
          color: #000;
          font-weight: 500;
          word-break: break-word;
        }

        /* Tablet */
        @media (max-width: 768px) {
          .pref-label {
            flex: 0 0 150px;
            font-size: 14px;
          }

          .pref-value {
            font-size: 14px;
          }
        }

        /* Small Mobile */
        @media (max-width: 480px) {
          .pref-label {
            flex: 0 0 120px;
            font-size: 13px;
          }

          .pref-value {
            font-size: 13px;
          }
        }

        /* 320px */
        @media (max-width: 360px) {
          .pref-label {
            flex: 0 0 100px;
            font-size: 12px;
          }

          .pref-value {
            font-size: 12px;
          }

          .pref-icon {
            width: 15px;
            height: 15px;
          }
        }
        `}
      </style>
    </>
  );
};

const normalizeFullProfileResponse = (api) => {
  if (!api) return null;

  return {
    verified_status: api.verified_status === true,
    search: {
      user_info: {
        register_id: api.user_id,
        lastSeen: api.lastSeen || null,

        username: api.userName,
        name: api.basic_details?.full_name || "",
        age: api.basic_details?.age || "",
        gender: api.basic_details?.gender || "",

        register_by_value: api.basic_details?.profile_managed_by || "",

        date_of_birth: api.basic_details?.date_of_birth || "",

        city: api.basic_details?.city || "",
        height: api.basic_details?.height || "",
        marital_status_value: api.basic_details?.marital_status || "",
        bloodGroup: api.basic_details?.blood_group || "",

        childnum_value: api.basic_details?.number_of_children || "",

        child_living_value: api.basic_details?.children_living_status || "",

        mobile_number: api.basic_details?.mobile_number || "",

        about_me: api.basic_details?.about_me || "",

        education: api.education_career?.education || "",
        educationDetail: api.education_career?.about_my_education || "",

        occupation: api.education_career?.job_title || "",
        occupationDetail: api.education_career?.about_my_professional || "",
        income_value: api.education_career?.annual_income || "",

        residing_country: api.education_career?.residence_country || "",
        residing_state: api.education_career?.residence_state || "",
        residing_city: api.education_career?.residence_city || "",

        fatherName: api.family_details?.father_name || "",
        fatherProfessions: api.family_details?.father_profession || "",
        motherName: api.family_details?.mother_name || "",
        motherProfession: api.family_details?.mother_profession || "",

        marriedBrothers: api.family_details?.married_brother || 0,
        unMarriedBrothers: api.family_details?.unmarried_brother || 0,
        marriedSister: api.family_details?.married_sister || 0,
        unMarriedSister: api.family_details?.unmarried_sister || 0,

        familyOrigin: api.family_details?.family_origin || "",
        family_types: api.family_details?.family_type || "",
        family_status: api.family_details?.family_status || "",
        family_values: api.family_details?.family_values || "",
        aboutFamily: api.family_details?.about_my_family || "",

        familyNativeCity: api.family_details?.native_city || "",
        familyNativeState: api.family_details?.native_state || "",
        familyNativeCountry: api.family_details?.native_country || "",

        religion: api.religion_kundli_astro?.religion || "",
        caste: api.religion_kundli_astro?.caste || "",
        subcaste: api.religion_kundli_astro?.subcaste || "",
        gothram: api.religion_kundli_astro?.gothram || "",
        star_value: api.religion_kundli_astro?.star || "",
        padam_value: api.religion_kundli_astro?.padam || "",
        sevvaiDosham: api.religion_kundli_astro?.sevvai_dosham || "",
        domain: api.religion_kundli_astro?.domain || "",
        mother_tongue_value: api.religion_kundli_astro?.mother_tongue || "",
        weight_value: api.lifestyle?.weight || "",
        physical_status_value: api.lifestyle?.physical_status || "",
        body_type_value: api.lifestyle?.body_type || "",
        complexion_value: api.lifestyle?.complexion || "",

        photo: api.profilePhoto || "",
        photoCount: api.photoCount || 0,
        membership_type: api.profile_membership_type || "",
        profile_membership_type:
          api.profile_membership_type || api.membership_type || "",
        lastLogin: "",

        owner_img: api.preference_matching?.owner_img || "",

        photo_visible: true,
      },

      // hobbies: {
      //   original: (api.hobbies || []).map((h) => ({
      //     hobbies_type: {
      //       type: h.type,
      //       hobbies: h.name.split(",").map((x) => x.trim()),
      //     },
      //   })),
      // },

      hobbies: {
        original: (api.hobbies || []).map((h) => ({
          hobbies_type: {
            type: h.type,
            hobbies: Array.isArray(h.name) ? h.name : [],
          },
        })),
      },

      partner: {
        aboutLifePartner: api.habits?.about_my_partner || "",
      },

      habits: {
        eating: api.habits?.eating_habits || "",
        drinking: api.habits?.drinking_habits || "",
        smoking: api.habits?.smoking_habits || "",
      },

      owner_img: api.preference_matching?.owner_img || "",
      total_matches: api.preference_matching?.matched_criteria ?? 0,
      total_criteria: api.preference_matching?.total_criteria ?? 0,

      match_result: transformDesiredPartner(api.desired_partner_details),

      interest_sent: api.interest_sent,
      interest_received: api.interest_received,
      interest_i_accept: api.interest_i_accept,
      interest_i_reject: api.interest_i_reject,
      shortlisted: api.shortlisted,
      ignored: api.ignored,
    },
  };
};

const transformDesiredPartner = (details = {}) => {
  const out = {};

  Object.entries(details).forEach(([section, items]) => {
    const sectionData = {};

    items.forEach((item) => {
      const key = item.label.replace(/\s+/g, "_").toLowerCase();
      sectionData[key] = {
        value: item.value ?? "",
        match: item.status ? "Yes" : "No",
      };
    });

    out[section] = sectionData;
  });

  return out;
};

export const ProfileView = () => {
  const location = useLocation();

  const [openContactModal, setOpenContactModal] = useState(false);
  const [contactInfo, setContactInfo] = useState(null);

  // near other useState calls
  const [showStickyActions, setShowStickyActions] = useState(false);

  // Add this ref (place it near other refs or state declarations)
  const desiredPartnerRef = React.useRef(null);
  const mainContainerRef = React.useRef(null);
  const [stickyStyles, setStickyStyles] = useState({
    width: "auto",
    left: "50%",
  });

  const handleContactResult = (data) => {
    setContactInfo(data);
    setOpenContactModal(true);
  };

  const hasAnyValue = (...values) =>
    // values.some((v) => v !== null && v !== undefined && v !== "");
    values.some(
      (v) =>
        v !== null &&
        v !== undefined &&
        v !== "" &&
        !(typeof v === "number" && v === 0),
    );

  const { id } = useParams();
  const navigate = useNavigate();
  // const { user_id } = location.state || {}; // Get user_id from location state

  const { user_id, username, userId, last_viewed } = location.state || {};

  // console.log("📥 ProfileView received state:", { userId, username, id });

  const [isShortlisted, setIsShortlisted] = useState(false);

  const [profileData, setProfileData] = useState(null); // State for profile data

  console.log("PROFILE DATA PASSED TO ACTION:", profileData);

  const [loading, setLoading] = useState(true); // State for loading indicator
  const [imageSize, setImageSize] = useState({ width: 960, height: 0 });
  const [blurValue, setBlurValue] = useState(10); // Default blur value as in SliderComponent
  const [loadingRequest, setLoadingRequest] = useState(null); // Track photo request loading state
  const bannerHeight = 263; // Height of the banner
  const gender = localStorage.getItem("gender");

  const defaultImage = gender === "F" ? maleImg : femaleImg;
  const profileImg = gender === "M" ? boyImg : gitlImg;
  const [open, setOpen] = useState(false);

  // expanded states
  const [aboutMeExpanded, setAboutMeExpanded] = useState(false);
  const [aboutEducationExpanded, setAboutEducationExpanded] = useState(false);
  const [aboutProfessionExpanded, setAboutProfessionExpanded] = useState(false);
  const [aboutFamilyExpanded, setAboutFamilyExpanded] = useState(false);
  const [aboutPartnerExpanded, setAboutPartnerExpanded] = useState(false);

  const aboutMeRef = React.useRef(null);
  const aboutEducationRef = React.useRef(null);
  const aboutProfessionRef = React.useRef(null);
  const aboutFamilyRef = React.useRef(null);
  const aboutPartnerRef = React.useRef(null);

  const [showAboutMeToggle, setShowAboutMeToggle] = useState(false);
  const [showAboutEducationToggle, setShowAboutEducationToggle] =
    useState(false);
  const [showAboutProfessionToggle, setShowAboutProfessionToggle] =
    useState(false);
  const [showAboutFamilyToggle, setShowAboutFamilyToggle] = useState(false);
  const [showAboutPartnerToggle, setShowAboutPartnerToggle] = useState(false);

  useEffect(() => {
    const checkOverflow = (ref, setter) => {
      if (!ref?.current) return;

      const el = ref.current;
      if (el.scrollHeight > el.clientHeight) {
        setter(true);
      } else {
        setter(false);
      }
    };

    const timer = setTimeout(() => {
      checkOverflow(aboutMeRef, setShowAboutMeToggle);
      checkOverflow(aboutEducationRef, setShowAboutEducationToggle);
      checkOverflow(aboutProfessionRef, setShowAboutProfessionToggle);
      checkOverflow(aboutFamilyRef, setShowAboutFamilyToggle);
      checkOverflow(aboutPartnerRef, setShowAboutPartnerToggle);
    }, 100);

    return () => clearTimeout(timer);
  }, [profileData]);

  const loggedGender = localStorage.getItem("gender");
  const loggedUsername = localStorage.getItem("username") || "";

  let connectionHeartIcon = HeartMale; // default fallback

  if (loggedGender === "M") connectionHeartIcon = HeartMale;
  else if (loggedGender === "F") connectionHeartIcon = HeartFemale;
  else {
    // fallback based on username prefix
    if (loggedUsername.startsWith("F")) connectionHeartIcon = HeartMale;
    else if (loggedUsername.startsWith("M")) connectionHeartIcon = HeartFemale;
  }

  const [bookmarkAnimating, setBookmarkAnimating] = useState(false);

  const handleToggleBookmark = async () => {
    const current = isShortlisted;

    // trigger animation
    setBookmarkAnimating(true);
    setIsShortlisted(!current);

    try {
      await profileActivityJava({
        user_id: profileData.search.user_info.register_id,
        response_type: current ? "remove_bookmark" : "bookmark",
      });
    } catch (error) {
      setIsShortlisted(current);
      toast.error("Unable to update shortlist");
    } finally {
      setTimeout(() => setBookmarkAnimating(false), 300);
    }
  };

  // const handleContactClickFromProfile = async () => {
  //   const recipientId = profileData.search.user_info.register_id;

  //   if (!recipientId) {
  //     toast.error("Profile id missing. Unable to fetch contact.");
  //     return;
  //   }

  //   try {
  //     const response = await contactViewJava({
  //       toUserId: recipientId,
  //     });

  //     if (response.status === 200 || response.status === 201) {
  //       handleContactResult({
  //         type: "success",
  //         phone: response.data.message,
  //         message: null,
  //         username: profileData.search.user_info.username,
  //         photo: profileData.search.user_info.photo,
  //       });
  //     } else {
  //       handleContactResult({
  //         type: "error",
  //         phone: null,
  //         message: response.data.message,
  //         username: profileData.search.user_info.username,
  //         photo: profileData.search.user_info.photo,
  //       });
  //     }
  //   } catch (error) {
  //     handleContactResult({
  //       type: "error",
  //       phone: null,
  //       message:
  //         error.response?.data?.message || "Failed to retrieve contact info",
  //       username: profileData.search.user_info.username,
  //       photo: profileData.search.user_info.photo,
  //     });
  //   }
  // };

  const handleContactClickFromProfile = async () => {
    const recipientId = profileData?.search?.user_info?.register_id;

    if (!recipientId) {
      toast.error("Profile id missing. Unable to fetch contact.");
      return;
    }

    try {
      const response = await contactViewJava({ toUserId: recipientId });

      const { status, message, errorCode } = response.data || {};

      if (status === true) {
        // ✅ success → message contains mobile number
        handleContactResult({
          type: "success",
          phone: message,
          message: null,
          errorCode: null, // ✅ ADD
          username: profileData.search.user_info.username,
          photo: profileData.search.user_info.photo,
        });
      } else {
        // ✅ error → show modal with message + errorCode
        handleContactResult({
          type: "error",
          phone: null,
          message: message || "Unable to fetch contact details.",
          errorCode: errorCode || null, // ✅ ADD
          username: profileData.search.user_info.username,
          photo: profileData.search.user_info.photo,
        });
      }
    } catch (error) {
      handleContactResult({
        type: "error",
        phone: null,
        message:
          error.response?.data?.message || "Failed to retrieve contact info",
        errorCode: error.response?.data?.errorCode || null,
        username: profileData.search.user_info.username,
        photo: profileData.search.user_info.photo,
      });
    }
  };

  // useEffect(() => {
  //   console.log("[Sticky] Observer setup");

  //   const element = desiredPartnerRef.current;
  //   if (!element) {
  //     console.log("[Sticky] Ref still null");
  //     return;
  //   }

  //   console.log("[Sticky] Observing element:", element);

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       entries.forEach((entry) => {
  //         const { isIntersecting, boundingClientRect } = entry;

  //         console.log(
  //           "[Sticky] → visible:",
  //           isIntersecting,
  //           "| top:",
  //           Math.round(boundingClientRect.top),
  //           "| bottom:",
  //           Math.round(boundingClientRect.bottom),
  //           "| ratio:",
  //           entry.intersectionRatio.toFixed(2),
  //         );

  //         // Show if:
  //         // - The element is intersecting OR
  //         // - It has scrolled past (bottom < window height means it's above but we already passed it)
  //         const isVisibleOrPassed =
  //           isIntersecting ||
  //           (boundingClientRect.bottom < window.innerHeight &&
  //             boundingClientRect.top < 0);

  //         setShowStickyActions(isVisibleOrPassed);
  //       });
  //     },
  //     {
  //       root: null, // viewport
  //       rootMargin: "200px 0px -100px 0px", // appear 200px earlier, disappear 100px after fully gone
  //       threshold: [0, 0.1, 0.5], // catch entry and exit smoothly
  //     },
  //   );

  //   observer.observe(element);

  //   return () => {
  //     console.log("[Sticky] Disconnecting observer");
  //     observer.disconnect();
  //   };
  // }, [profileData]);

  useEffect(() => {
    const handleScroll = () => {
      // 1. Calculate Visibility
      const partnerEl = desiredPartnerRef.current;
      if (partnerEl) {
        const partnerRect = partnerEl.getBoundingClientRect();
        // Show as soon as the top of the section enters the viewport
        if (partnerRect.top <= window.innerHeight) {
          setShowStickyActions(true);
        } else {
          setShowStickyActions(false);
        }
      }

      // 2. Calculate Width and Horizontal Position
      const containerEl = mainContainerRef.current;
      if (containerEl) {
        const containerRect = containerEl.getBoundingClientRect();
        setStickyStyles({
          width: `${containerRect.width}px`,
          left: `${containerRect.left}px`,
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll(); // run once

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [profileData]);

  // Function to handle share button click
  const handleShareClick = () => {
    const profileId = user_id || id; // Get the profile ID from either user_id or id
    if (!profileId) {
      toast.error("Unable to generate share link");
      return;
    }

    const profileUrl = `${window.location.origin}/profile-view/${profileId}`;

    // Copy to clipboard
    navigator.clipboard
      .writeText(profileUrl)
      .then(() => {
        toast.success("Profile link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        toast.error("Failed to copy link");
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchProfileData();
  }, [location.state, id]);

  const buildProfilePayload = (value) => {
    if (!value) return {};

    const input = String(value).trim();
    const lower = input.toLowerCase();

    // Case 1: Matrimony ID (Mxxxxx / Fxxxxx)
    if (lower.startsWith("m") || lower.startsWith("f")) {
      return { username: input };
    }

    // Case 2: Numeric ID
    return { userId: input };
  };

  const fetchProfileData = async () => {
    const identifier = userId || id || username;

    if (!identifier) {
      setLoading(false);
      return;
    }

    try {
      const payload = buildProfilePayload(identifier);
      const response = await getFullProfileByUsername(payload);

      // 🔴 HANDLE PROFILE NOT AVAILABLE
      if (!response.data?.status) {
        setProfileData(null); // prevent crash
        setLoading(false);
        toast.error(response.data?.message || "Profile not available");
        return;
      }

      // ✅ Normal flow
      setProfileData({
        ...normalizeFullProfileResponse(response.data.data),
        membership_type: response.data.membership_type,
      });
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to load profile");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (profileData?.search?.shortlisted !== undefined) {
      setIsShortlisted(profileData.search.shortlisted);
    }
  }, [profileData]);

  useEffect(() => {
    if (!profileData) return;

    const imageUrl = profileData.search?.user_info?.photo || defaultImage;

    if (!imageUrl) return;

    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      setImageSize({ width: img.width, height: img.height });
    };
  }, [profileData]);

  if (loading) {
    return (
      <div className="col-lg-9 col-12 text-left">
        {/* Skeleton Loader for CardHeader */}
        <Skeleton variant="rectangular" width="100%" height={50} />
        {/* Skeleton Loader for Profile Details */}
        <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
        <div style={{ display: "flex", gap: "10px" }}>
          <Skeleton variant="text" width="100px" height={30} />
          <Skeleton variant="text" width="150px" height={30} />
        </div>
        {/* Skeleton Loader for Other Profile Details */}
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="rectangular" width="100%" height={bannerHeight} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
        <Skeleton variant="text" width="100%" height={25} />
      </div>
    );
  }
  // if (!profileData) return <p>No Profile Data Available.</p>; // Handle no data

  if (!profileData?.search?.user_info) {
    return (
      <div
        className="col-lg-9 col-12 text-center"
        style={{ padding: "60px 20px" }}
      >
        <h3 style={{ color: "#FF3C3C" }}>No Data Available</h3>
        {/* <p style={{ color: "#666", marginTop: "10px" }}>
        The member may have deactivated their account.
      </p> */}

        <button
          onClick={() => navigate(-1)}
          style={{
            marginTop: "20px",
            padding: "8px 20px",
            borderRadius: "6px",
            border: "none",
            background: "#FF8008",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Go Back
        </button>
      </div>
    );
  }

  const matchedCount = profileData.search?.total_matches ?? 0;
  const totalCriteria = profileData.search?.total_criteria ?? 0;

  const matchText = `${matchedCount} / ${totalCriteria} preferences aligned.`;

  const imageUrl = profileData.search.user_info?.photo || defaultImage;
  const isPhotoVisible = profileData.search.user_info?.photo_visible !== false;
  const imageBase64 = profileData.search.user_info.photo_base64;
  const photoPrivacySetting =
    profileData.search.user_info?.photo_privacy_setting;

  // Function to get the image size
  const getImageSize = (url) => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setImageSize({ width: img.width, height: img.height });
    };

    img.onerror = () => {
      console.error("Error loading image");
    };
  };

  const handleEdit = (path, data) => {
    navigate(path, { state: { userId: data } });
  };

  const habits = [];

  const habitData = profileData.search.habits || {};

  if (isValidValue(habitData.eating)) {
    habits.push({
      icon: DietaryHabitsIcon,
      label: "Dietary Habits",
      value: habitData.eating,
    });
  }

  if (isValidValue(habitData.drinking)) {
    habits.push({
      icon: DrinkHabitIcon,
      label: "Drinking Habits",
      value: habitData.drinking,
    });
  }

  if (isValidValue(habitData.smoking)) {
    habits.push({
      icon: SmokingHabitIcon,
      label: "Smoking Habits",
      value: habitData.smoking,
    });
  }

  const hobbyCategories = [];

  if (Array.isArray(profileData?.search?.hobbies?.original)) {
    profileData.search.hobbies.original.forEach((item) => {
      const rawType = item?.hobbies_type?.type || "";
      const hobbyList = item?.hobbies_type?.hobbies || [];

      if (hobbyList.length > 0) {
        // Format title -> "Favourite_Movies" → "Movies"
        const formattedTitle = rawType
          .replace(/^Favourite_/, "")
          .replace(/^Favorite_/, "")
          .replace(/_/g, " ")
          .trim();

        hobbyCategories.push({
          title: formattedTitle,
          hobbies: hobbyList,
        });
      }
    });
  }

  const showBasicDetails = hasAnyValue(
    profileData.search.user_info.register_by_value,
    profileData.search.user_info.name,
    profileData.search.user_info.date_of_birth,
    profileData.search.user_info.height,
    profileData.search.user_info.marital_status_value,
    profileData.search.user_info.bloodGroup,
    profileData.search.user_info.childnum_value,
    profileData.search.user_info.child_living_value,
  );

  const showContactDetails = hasAnyValue(
    profileData.search.user_info.mobile_number,
  );

  const isFreeUser = profileData?.membership_type === "Free";

  const showEducation = hasAnyValue(
    profileData.search.user_info.education,
    profileData.search.user_info.educationDetail,
  );

  const showCareer = hasAnyValue(
    profileData.search.user_info.occupation,
    profileData.search.user_info.occupationDetail,
    profileData.search.user_info.income_value,
    profileData.search.user_info.residing_country,
    profileData.search.user_info.residing_state,
    profileData.search.user_info.residing_city,
  );

  const showFamily = hasAnyValue(
    profileData.search.user_info.fatherName,
    profileData.search.user_info.fatherProfessions,
    profileData.search.user_info.motherName,
    profileData.search.user_info.motherProfession,
    profileData.search.user_info.family_values,
    profileData.search.user_info.family_types,
    profileData.search.user_info.family_status,
    profileData.search.user_info.familyOrigin,
    profileData.search.user_info.aboutFamily,
    profileData.search.user_info.marriedBrothers,
    profileData.search.user_info.unMarriedBrothers,
    profileData.search.user_info.marriedSister,
    profileData.search.user_info.unMarriedSister,

    profileData.search.user_info.familyNativeCity,
    profileData.search.user_info.familyNativeState,
    profileData.search.user_info.familyNativeCountry,
  );

  const showReligion = hasAnyValue(
    profileData.search.user_info.domain,
    profileData.search.user_info.religion,
    profileData.search.user_info.caste,
    profileData.search.user_info.subcaste,
    profileData.search.user_info.gothram,
    profileData.search.user_info.star_value,
    profileData.search.user_info.padam_value,
    profileData.search.user_info.sevvaiDosham,
    profileData.search.user_info.mother_tongue_value,
  );

  const showLifestyle = hasAnyValue(
    profileData.search.user_info.weight_value,
    profileData.search.user_info.physical_status_value,
    profileData.search.user_info.body_type_value,
    profileData.search.user_info.complexion_value,
  );

  const verifiedStatus = profileData?.verified_status || false;

  const UpgradeOrViewButton = ({ onClick, type = "upgrade" }) => (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        height: "33px",
        padding: "0 16px",
        borderRadius: "8px",
        background:
          "linear-gradient(90deg, rgba(255,119,5,0.77), rgba(230,0,0,0.71) 98.47%)",
        color: "#FFF",
        fontSize: "12px",
        fontWeight: 600,
        fontFamily: "Montserrat, sans-serif",
        cursor: "pointer",
        whiteSpace: "nowrap",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
      onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
    >
      <img
        src={lockContact}
        width="15"
        height="15"
        alt="lock"
        style={{ marginBottom: "1px" }}
      />
      {type === "upgrade" ? "Upgrade to View" : "Tap to View"}
    </div>
  );

  return (
    <div className="col-lg-9 col-12 text-left" ref={mainContainerRef}>
      <CardHeader
        avatar={
          <ArrowBack sx={{ color: "#FF8008" }} onClick={() => navigate(-1)} />
        }
        action={
          <IconButton aria-label="share" onClick={handleShareClick}>
            <ShareIcon sx={{ color: "#FF8008" }} />
          </IconButton>
        }
        title="Profile Overview"
        subheader=""
        titleTypographyProps={{
          sx: { color: "#000", fontSize: "20px", fontWeight: "600" },
        }}
      />
      {/* <!-- Slider Start --> */}
      <div
        id="carouselExampleControlsNoTouching"
        className="carousel slide"
        data-bs-touch="false"
        data-bs-interval="false"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <div className="editProfileBlock">
              <ProfileHeader
                imageUrl={imageUrl}
                isPhotoVisible={isPhotoVisible}
                defaultImage={defaultImage}
                imageBase64={imageBase64}
                photoCount={profileData.search.user_info.photoCount}
                lastSeenText={profileData?.search?.user_info?.lastSeen || ""}
                verifiedStatus={verifiedStatus}
                lastViewedText={last_viewed || ""}
                // lastSeenText={ profileData?.search?.user_info?.lastLogin || last_viewed || "" }
                // membershipType={
                //   profileData?.search?.user_info?.profile_membership_type
                // }
                membershipType={profileData?.search?.user_info?.profile_membership_type?.trim()}
                userName={profileData.search.user_info.name}
                userId={profileData.search.user_info.username}
                // isShortlisted={profileData.search.shortlisted}

                isShortlisted={isShortlisted}
                bookmarkAnimating={bookmarkAnimating}
                onToggleBookmark={handleToggleBookmark}
                //   handleViewPhotos={() =>
                //     handleEdit(
                //       "/view-user-photos",
                //       profileData.search.user_info.register_id
                //     )
                //   }
                // />

                handleViewPhotos={() => {
                  const id = profileData.search.user_info.register_id;

                  console.log("[PROFILE VIEW] navigating to photos of", id);

                  navigate(`/view-user-photos/${id}`);
                }}
              />

              <div className="mainProfileBG" style={{ paddingBottom: "130px" }}>
                {/* <div className="profileTltGirl d-flex justify-content-between align-items-center">
                  <h3>Profile Details</h3>
                  {profileData.search.user_info.membership_type !== "Free " && (
                    <h3 className="redTxtBG">
                      {profileData.search.user_info.membership_type}
                    </h3>
                  )}
                </div> */}

                <div className="personlDetails px-4">
                  <div className="row">
                    {/* ================= BASIC DETAILS CARD (NEW UI) ================= */}

                    {showBasicDetails && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* -------- HEADER -------- */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <img
                              src={BasicDetailsIcon}
                              width="32"
                              height="32"
                              alt="basic details"
                            />

                            <div>
                              <div
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#000",
                                }}
                              >
                                Basic Details
                              </div>

                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(79,79,79,0.7)",
                                }}
                              >
                                A brief overview of personal information.
                              </div>
                            </div>
                          </div>

                          {/* RIGHT-SIDE LOCATION (AS PER SCREENSHOT) */}
                          {/* {(profileData.search.user_info.city ||
                            profileData.search.user_info.state) && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <img
                                src={locationIcon}
                                width="20"
                                height="20"
                                alt="location"
                              />
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: 500,
                                  color: "#4F4F4F",
                                }}
                              >
                                {profileData.search.user_info.city}
                                {profileData.search.user_info.state
                                  ? `, ${profileData.search.user_info.state}`
                                  : ""}
                              </span>
                            </div>
                          )} */}
                        </div>

                        {/* -------- DIVIDER -------- */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* -------- DETAILS GRID -------- */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          <DetailRow
                            label="Profile Created By"
                            value={
                              profileData.search.user_info.register_by_value
                            }
                          />

                          <DetailRow
                            label="Age"
                            value={profileData.search.user_info.age}
                          />

                          <DetailRow
                            label="Gender"
                            value={(() => {
                              const g = profileData.search.user_info.gender;
                              if (!g) return "--";

                              const gender = g.trim().toLowerCase();
                              if (gender === "male" || gender === "m")
                                return "Male";
                              if (gender === "female" || gender === "f")
                                return "Female";

                              return "--";
                            })()}
                          />

                          <DetailRow
                            label="Date of Birth"
                            value={
                              isFreeUser
                                ? profileData.search.user_info.date_of_birth
                                : profileData.search.user_info.date_of_birth
                            }
                            rightAction={
                              isFreeUser ? (
                                <UpgradeOrViewButton
                                  type="upgrade"
                                  onClick={() => navigate("/upgrade")}
                                />
                              ) : null
                            }
                          />

                          {/* <DetailRow
                            label="Residing Place"
                            value={profileData.search.user_info.city}
                          /> */}

                          <DetailRow
                            label="Residing Place"
                            value={(() => {
                              const city = profileData.search.user_info.city;
                              const state =
                                profileData.search.user_info.residing_state;

                              if (city && state) return `${city}, ${state}`;
                              return city || state || "";
                            })()}
                          />

                          <DetailRow
                            label="Height"
                            value={profileData.search.user_info.height}
                          />

                          <DetailRow
                            label="Blood Group"
                            value={profileData.search.user_info.bloodGroup}
                          />

                          <DetailRow
                            label="Marital Status"
                            value={
                              profileData.search.user_info.marital_status_value
                            }
                          />

                          <DetailRow
                            label="Number of Children"
                            value={profileData.search.user_info.childnum_value}
                          />

                          <DetailRow
                            label="Children Living Status"
                            value={
                              profileData.search.user_info.child_living_value
                            }
                          />
                        </div>

                        {/* ================= ABOUT ME ================= */}

                        {isValidValue(
                          profileData.search.user_info.about_me,
                        ) && (
                          <div
                            style={{
                              marginTop: "32px",
                              padding: "18px",
                              border: "1px solid #F1C9C9",
                              borderRadius: "8px",
                              background: "#FFF4F4",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                marginBottom: "8px",
                                background:
                                  "linear-gradient(90deg,#F78C25,#FF3C3C)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              <img
                                src={starIcon}
                                width="16"
                                height="18"
                                style={{ marginRight: "5px" }}
                                alt="about me"
                              />
                              About Me
                            </div>

                            {/* ✅ ADD THIS STYLE BLOCK */}
                            <style>
                              {`
        .about-collapsed {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .about-expanded {
          overflow: visible;
        }
      `}
                            </style>

                            <div
                              ref={aboutMeRef}
                              className={
                                aboutMeExpanded
                                  ? "about-expanded"
                                  : "about-collapsed"
                              }
                              style={{ fontSize: "15px", lineHeight: "22px" }}
                            >
                              {profileData.search.user_info.about_me}
                            </div>

                            {showAboutMeToggle && (
                                <div
                                  onClick={() =>
                                    setAboutMeExpanded(!aboutMeExpanded)
                                  }
                                  style={{
                                    marginTop: "6px",
                                    color: "#FF6F61",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    width: "fit-content",
                                  }}
                                >
                                  {aboutMeExpanded ? "Show less" : "See all"}
                                </div>
                              )
                            }
                          </div>
                        )}
                      </div>
                    )}

                    {/* ================= CONTACT DETAILS CARD ================= */}
                    {showContactDetails && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* -------- HEADER -------- */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={ContactIcon}
                            width="32"
                            height="32"
                            alt="contact details"
                          />

                          <div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#000",
                              }}
                            >
                              Contact Details
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "rgba(79,79,79,0.7)",
                              }}
                            >
                              Contact information shared on profile.
                            </div>
                          </div>
                        </div>

                        {/* -------- DIVIDER -------- */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* -------- DETAILS GRID -------- */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          {/* <DetailRow
                            label="Mobile Number"
                            value={profileData.search.user_info.mobile_number}
                          /> */}

                          <DetailRow
                            label="Mobile Number"
                            value={profileData.search.user_info.mobile_number}
                            rightAction={
                              <UpgradeOrViewButton
                                // isFreeUser={isFreeUser}
                                type={isFreeUser ? "upgrade" : "view"}
                                onClick={() => {
                                  if (isFreeUser) {
                                    navigate("/upgrade");
                                  } else {
                                    handleContactClickFromProfile();
                                  }
                                }}
                              />
                            }
                          />
                        </div>
                      </div>
                    )}

                    {/* ================= EDUCATION CARD ================= */}
                    {showEducation && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <img
                              src={EducationIcon}
                              width="32"
                              height="32"
                              alt="education"
                            />

                            <div>
                              <div
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#000",
                                }}
                              >
                                Education
                              </div>
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(79,79,79,0.7)",
                                }}
                              >
                                Educational background and qualifications.
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* GRID DETAILS */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          <DetailRow
                            label="Education"
                            value={profileData.search.user_info.education}
                          />

                          {/* <DetailRow
                            label="Education Detail"
                            value={profileData.search.user_info.educationDetail}
                          /> */}
                        </div>

                        {isValidValue(
                          profileData.search.user_info.educationDetail,
                        ) && (
                          <div
                            style={{
                              marginTop: "32px",
                              padding: "18px",
                              border: "1px solid #F1C9C9",
                              borderRadius: "8px",
                              background: "#FFF4F4",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                marginBottom: "8px",
                                background:
                                  "linear-gradient(90deg,#F78C25,#FF3C3C)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              <img
                                src={starIcon}
                                width="16"
                                height="18"
                                style={{ marginRight: "5px" }}
                                alt="about education"
                              />
                              About Education
                            </div>
                            <div
                              ref={aboutEducationRef}
                              className={
                                aboutEducationExpanded
                                  ? "about-expanded"
                                  : "about-collapsed"
                              }
                            >
                              {profileData.search.user_info.educationDetail}
                            </div>
                            {showAboutEducationToggle && (
                                <div
                                  onClick={() =>
                                    setAboutEducationExpanded(
                                      !aboutEducationExpanded,
                                    )
                                  }
                                  style={{
                                    marginTop: "6px",
                                    color: "#FF6F61",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    width: "fit-content",
                                  }}
                                >
                                  {aboutEducationExpanded
                                    ? "Show less"
                                    : "See all"}
                                </div>
                              )
                            }
                          </div>
                        )}
                      </div>
                    )}

                    {/* ================= CAREER CARD ================= */}

                    {showCareer && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <img
                              src={jobIcon}
                              width="32"
                              height="32"
                              alt="career"
                            />

                            <div>
                              <div
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#000",
                                }}
                              >
                                Profession
                              </div>
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(79,79,79,0.7)",
                                }}
                              >
                                Work, income, and professional background.
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* GRID DETAILS */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          <DetailRow
                            label="Profession"
                            value={profileData.search.user_info.occupation}
                          />

                          {/* <DetailRow
                            label="Profession Detail"
                            value={
                              profileData.search.user_info.occupationDetail
                            }
                          /> */}

                          <DetailRow
                            label="Annual Income"
                            value={
                              profileData.search.user_info.income_value
                                ? `${profileData.search.user_info.income_value} P.A`
                                : ""
                            }
                          />

                          <DetailRow
                            label="Residence City"
                            value={profileData.search.user_info.residing_city}
                          />

                          <DetailRow
                            label="Residence State"
                            value={profileData.search.user_info.residing_state}
                          />

                          <DetailRow
                            label="Residence Country"
                            value={
                              profileData.search.user_info.residing_country
                            }
                          />
                        </div>

                        {isValidValue(
                          profileData.search.user_info.occupationDetail,
                        ) && (
                          <>
                            {/* ================= FREE USER (LOCKED UI) ================= */}
                            {isFreeUser ? (
                              <div
                                style={{
                                  marginTop: "32px",
                                  padding: "22px 24px",
                                  borderRadius: "12px",
                                  background: "#FFF4F4",
                                  border: "1px solid #F2B8B5",
                                }}
                              >
                                {/* HEADER */}
                                <div
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: 600,
                                    marginBottom: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    color: "#f3a057",
                                  }}
                                >
                                  <img
                                    src={starIcon}
                                    width="18"
                                    height="18"
                                    alt="professional details"
                                  />
                                  Profession Details
                                </div>

                                {/* BLURRED TEXT */}
                                <div
                                  style={{
                                    fontSize: "15px",
                                    lineHeight: "22px",
                                    color: "#6B6B6B",
                                    filter: "blur(4px)",
                                    userSelect: "none",
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                    maxHeight: "44px", // 2 lines × 22px line-height
                                  }}
                                >
                                  {
                                    profileData.search.user_info
                                      .occupationDetail
                                  }
                                </div>

                                {/* CENTERED UPGRADE BUTTON */}
                                <div
                                  style={{
                                    marginTop: "-40px",
                                    marginBottom: "15px",
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                >
                                  <div style={{ width: "fit-content" }}>
                                    <UpgradeOrViewButton
                                      // isFreeUser={true}
                                      type="upgrade"
                                      onClick={() => navigate("/upgrade")}
                                    />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              /* ================= PREMIUM USER (ORIGINAL UI — NO CHANGE) ================= */
                              <div
                                style={{
                                  marginTop: "32px",
                                  padding: "18px",
                                  border: "1px solid #F1C9C9",
                                  borderRadius: "8px",
                                  background: "#FFF4F4",
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    marginBottom: "8px",
                                    background:
                                      "linear-gradient(90deg,#F78C25,#FF3C3C)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                  }}
                                >
                                  <img
                                    src={starIcon}
                                    width="16"
                                    height="18"
                                    style={{ marginRight: "5px" }}
                                    alt="professional details"
                                  />
                                  Professional Details
                                </div>

                                <div
                                  ref={aboutProfessionRef}
                                  className={
                                    aboutProfessionExpanded
                                      ? "about-expanded"
                                      : "about-collapsed"
                                  }
                                >
                                  {
                                    profileData.search.user_info
                                      .occupationDetail
                                  }
                                </div>

                                {showAboutProfessionToggle && (
                                    <div
                                      onClick={() =>
                                        setAboutProfessionExpanded(
                                          !aboutProfessionExpanded,
                                        )
                                      }
                                      style={{
                                        marginTop: "6px",
                                        color: "#FF6F61",
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        textDecoration: "underline",
                                        width: "fit-content",
                                      }}
                                    >
                                      {aboutProfessionExpanded
                                        ? "Show less"
                                        : "See all"}
                                    </div>
                                  )
                                }
                              </div>
                            )}

                            {/* Shared Expand CSS */}
                            <style>
                              {`
        .about-collapsed {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .about-expanded {
          overflow: visible;
        }
      `}
                            </style>
                          </>
                        )}
                      </div>
                    )}

                    {/* ================= FAMILY DETAILS CARD ================= */}

                    {showFamily && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* -------- HEADER -------- */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={FamilyIcon}
                            width="32"
                            height="32"
                            alt="family"
                          />

                          <div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#000",
                              }}
                            >
                              Family Details
                            </div>
                            <div
                              style={{
                                fontSize: "14px",
                                color: "rgba(79,79,79,0.7)",
                              }}
                            >
                              Information about family background.
                            </div>
                          </div>
                        </div>

                        {/* -------- DIVIDER -------- */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* -------- DETAILS GRID -------- */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          {/* <DetailRow
                            label="Father's Name"
                            value={
                              isFreeUser
                                ? "******"
                                : profileData.search.user_info.fatherName
                            }
                            rightAction={
                              isFreeUser ? (
                                <UpgradeOrViewButton
                                  type="upgrade"
                                  onClick={() => navigate("/upgrade")}
                                />
                              ) : null
                            }
                          /> */}

                          {isValidValue(
                            profileData.search.user_info.fatherName,
                          ) && (
                            <DetailRow
                              label="Father's Name"
                              value={
                                isFreeUser
                                  ? profileData.search.user_info.fatherName
                                  : profileData.search.user_info.fatherName
                              }
                              rightAction={
                                isFreeUser ? (
                                  <UpgradeOrViewButton
                                    type="upgrade"
                                    onClick={() => navigate("/upgrade")}
                                  />
                                ) : null
                              }
                            />
                          )}

                          {/* <DetailRow
                            label="Mother's Name"
                            value={
                              isFreeUser
                                ? "******"
                                : profileData.search.user_info.motherName
                            }
                            rightAction={
                              isFreeUser ? (
                                <UpgradeOrViewButton
                                  type="upgrade"
                                  onClick={() => navigate("/upgrade")}
                                />
                              ) : null
                            }
                          /> */}

                          {isValidValue(
                            profileData.search.user_info.motherName,
                          ) && (
                            <DetailRow
                              label="Mother's Name"
                              value={
                                isFreeUser
                                  ? profileData.search.user_info.motherName
                                  : profileData.search.user_info.motherName
                              }
                              rightAction={
                                isFreeUser ? (
                                  <UpgradeOrViewButton
                                    type="upgrade"
                                    onClick={() => navigate("/upgrade")}
                                  />
                                ) : null
                              }
                            />
                          )}

                          <DetailRow
                            label="Father's Profession"
                            value={
                              profileData.search.user_info.fatherProfessions
                            }
                          />

                          <DetailRow
                            label="Mother's Profession"
                            value={
                              profileData.search.user_info.motherProfession
                            }
                          />

                          {/* -------- SIBLINGS (COMBINED FORMAT) -------- */}
                          <DetailRow
                            label="Siblings"
                            value={(() => {
                              const uB =
                                profileData.search.user_info
                                  .unMarriedBrothers || 0;
                              const mB =
                                profileData.search.user_info.marriedBrothers ||
                                0;
                              const uS =
                                profileData.search.user_info.unMarriedSister ||
                                0;
                              const mS =
                                profileData.search.user_info.marriedSister || 0;

                              const totalBrothers = uB + mB;
                              const totalSisters = uS + mS;

                              if (totalBrothers === 0 && totalSisters === 0)
                                return "--";

                              return `${totalBrothers} Brothers (${mB} married), ${totalSisters} Sisters (${mS} married)`;
                            })()}
                          />

                          <DetailRow
                            label="Family Origin"
                            value={profileData.search.user_info.familyOrigin}
                          />

                          <DetailRow
                            label="Family Type"
                            value={profileData.search.user_info.family_types}
                          />

                          <DetailRow
                            label="Family Status"
                            value={profileData.search.user_info.family_status}
                          />

                          <DetailRow
                            label="Family Value"
                            value={profileData.search.user_info.family_values}
                          />

                          <DetailRow
                            label="Native City"
                            value={
                              profileData.search.user_info.familyNativeCity
                            }
                          />

                          <DetailRow
                            label="Native State"
                            value={
                              profileData.search.user_info.familyNativeState
                            }
                          />

                          <DetailRow
                            label="Native Country"
                            value={
                              profileData.search.user_info.familyNativeCountry
                            }
                          />
                        </div>

                        {/* ================= ABOUT FAMILY (COLLAPSIBLE) ================= */}
                        {profileData.search.user_info.aboutFamily && (
                          <div
                            style={{
                              marginTop: "32px",
                              padding: "18px",
                              border: "1px solid #F1C9C9",
                              borderRadius: "8px",
                              background: "#FFF4F4",
                            }}
                          >
                            {/* Title */}
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: 600,
                                marginBottom: "8px",
                                background:
                                  "linear-gradient(90deg,#F78C25,#FF3C3C)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                              }}
                            >
                              <img
                                src={starIcon}
                                width="16"
                                height="18"
                                style={{ marginRight: "5px" }}
                                alt="about family"
                              />
                              About Family
                            </div>

                            {/* Embedded CSS for expansion */}
                            <style>{`
        .about-family-collapsed {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .about-family-expanded {
          overflow: visible;
        }
      `}</style>

                            {/* Family Text */}
                            <div
                              ref={aboutFamilyRef}
                              className={
                                aboutFamilyExpanded
                                  ? "about-family-expanded"
                                  : "about-family-collapsed"
                              }
                              style={{
                                fontSize: "15px",
                                color: "rgba(79,79,79,0.85)",
                                lineHeight: "22px",
                                transition: "all 0.3s ease",
                              }}
                            >
                              {profileData.search.user_info.aboutFamily}
                            </div>

                            {/* Toggle */}
                            {showAboutFamilyToggle && (
                                <div
                                  onClick={() =>
                                    setAboutFamilyExpanded(!aboutFamilyExpanded)
                                  }
                                  style={{
                                    marginTop: "6px",
                                    color: "#FF6F61",
                                    fontWeight: 600,
                                    cursor: "pointer",
                                    fontSize: "14px",
                                    textDecoration: "underline",
                                    width: "fit-content",
                                  }}
                                >
                                  {aboutFamilyExpanded
                                    ? "Show less"
                                    : "See all"}
                                </div>
                              )
                            }
                          </div>
                        )}
                      </div>
                    )}

                    {/* ================= RELIGION • KUNDLI • ASTRO CARD ================= */}

                    {showReligion && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={ReligionAstroIcon}
                            width="32"
                            height="32"
                            alt="religion astro"
                          />

                          <div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#000",
                              }}
                            >
                              Religion, Kundli & Astro
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "rgba(79,79,79,0.7)",
                              }}
                            >
                              Religious and astrological background.
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* DETAILS GRID */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          <DetailRow
                            label="Domain"
                            value={profileData.search.user_info.domain}
                          />

                          <DetailRow
                            label="Religion"
                            value={profileData.search.user_info.religion}
                          />

                          <DetailRow
                            label="Caste"
                            value={profileData.search.user_info.caste}
                          />

                          <DetailRow
                            label="Sub Caste"
                            value={profileData.search.user_info.subcaste}
                          />

                          <DetailRow
                            label="Gothram"
                            value={profileData.search.user_info.gothram}
                          />

                          <DetailRow
                            label="Padam"
                            value={profileData.search.user_info.padam_value}
                          />

                          <DetailRow
                            label="Star"
                            value={profileData.search.user_info.star_value}
                          />

                          <DetailRow
                            label="Sevvai Dosham"
                            value={profileData.search.user_info.sevvaiDosham}
                          />

                          <DetailRow
                            label="Mother Tongue"
                            value={
                              profileData.search.user_info.mother_tongue_value
                            }
                          />
                        </div>
                      </div>
                    )}

                    {/* ================= LIFESTYLE & INTERESTS CARD ================= */}
                    {showLifestyle && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px 0px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={LifestyleIcon}
                            width="32"
                            height="32"
                            alt="lifestyle icon"
                          />

                          <div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#000",
                              }}
                            >
                              Lifestyle & Interests
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "rgba(79,79,79,0.7)",
                              }}
                            >
                              Physical, personal & lifestyle preferences.
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* DETAILS GRID */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            rowGap: "18px",
                            fontSize: "16px",
                            color: "#4F4F4F",
                            fontWeight: 600,
                          }}
                        >
                          <DetailRow
                            label="Weight"
                            value={profileData.search.user_info.weight_value}
                          />

                          <DetailRow
                            label="Physical Status"
                            value={
                              profileData.search.user_info.physical_status_value
                            }
                          />

                          <DetailRow
                            label="Body Type"
                            value={profileData.search.user_info.body_type_value}
                          />

                          <DetailRow
                            label="Complexion"
                            value={
                              profileData.search.user_info.complexion_value
                            }
                          />
                        </div>
                      </div>
                    )}

                    {/* ================= HABITS SECTION ================= */}
                    {habits.length > 0 && (
                      <div
                        className="reveal-card reveal-delay-1"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* HEADER */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <img
                            src={HabitIcon}
                            width="32"
                            height="32"
                            alt="habit icon"
                          />

                          <div>
                            <div
                              style={{
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#000",
                              }}
                            >
                              Habits
                            </div>

                            <div
                              style={{
                                fontSize: "14px",
                                color: "rgba(79,79,79,0.7)",
                              }}
                            >
                              Favorite pastimes
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* HABITS ROW */}
                        <div
                          style={{
                            marginTop: "24px",
                            display: "flex",
                            justifyContent:
                              habits.length === 1
                                ? "flex-start"
                                : "space-between",
                            gap: "30px",
                            flexWrap: "wrap",
                          }}
                        >
                          {habits.map((item, index) => (
                            <div
                              key={index}
                              style={{
                                textAlign: "center",
                                flex: habits.length === 1 ? "0 0 auto" : "1",
                              }}
                            >
                              {/* ICON */}
                              <img
                                src={item.icon}
                                width="70"
                                height="70"
                                alt={item.label}
                                style={{ marginBottom: "8px" }}
                              />

                              {/* TEXT */}
                              <div
                                style={{
                                  fontSize: "16px",
                                  fontWeight: 600,
                                  color: "#000",
                                }}
                              >
                                {item.label} : {item.value}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* ================= ABOUT LIFE PARTNER (SAME UI AS ABOUT FAMILY) ================= */}
                    {profileData.search.partner.aboutLifePartner && (
                      <div
                        style={{
                          marginTop: "20px",
                          padding: "18px",
                          border: "1px solid #F1C9C9",
                          borderRadius: "8px",
                          background: "#FFF4F4",
                        }}
                      >
                        {/* Title */}
                        <div
                          style={{
                            fontSize: "16px",
                            fontWeight: 600,
                            marginBottom: "8px",
                            background:
                              "linear-gradient(90deg,#F78C25,#FF3C3C)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                          }}
                        >
                          <img
                            src={starIcon}
                            width="16"
                            height="18"
                            style={{ marginRight: "5px" }}
                            alt="about partner"
                          />
                          About Life Partner
                        </div>

                        {/* Embedded CSS for expansion */}
                        <style>
                          {`
        .about-partner-collapsed {
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .about-partner-expanded {
          overflow: visible;
        }
      `}
                        </style>

                        {/* Partner Text */}
                        <div
                          ref={aboutPartnerRef}
                          className={
                            aboutPartnerExpanded
                              ? "about-partner-expanded"
                              : "about-partner-collapsed"
                          }
                          style={{
                            fontSize: "15px",
                            color: "rgba(79,79,79,0.85)",
                            lineHeight: "22px",
                            transition: "all 0.3s ease",
                          }}
                        >
                          {profileData.search.partner.aboutLifePartner}
                        </div>

                        {/* Toggle Button */}
                        {showAboutPartnerToggle &&(
                            <div
                              onClick={() =>
                                setAboutPartnerExpanded(!aboutPartnerExpanded)
                              }
                              style={{
                                marginTop: "6px",
                                color: "#FF6F61",
                                fontWeight: 600,
                                cursor: "pointer",
                                fontSize: "14px",
                                textDecoration: "underline",
                                width: "fit-content",
                              }}
                            >
                              {aboutPartnerExpanded ? "Show less" : "See all"}
                            </div>
                          )
                        }
                      </div>
                    )}

                    {/* ================= HOBBIES CARD ================= */}
                    {hobbyCategories.length > 0 && (
                      <div
                        className="reveal-card reveal-delay-7"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "10px",
                          padding: "24px",
                          margin: "30px 0px",
                          boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                          border: "1px solid #E6EEF6",
                        }}
                      >
                        {/* ------- HEADER ------- */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "12px",
                            }}
                          >
                            <img
                              src={HobbiesIcon}
                              width="32"
                              height="32"
                              alt="hobbies"
                            />
                            <div>
                              <div
                                style={{
                                  fontSize: "20px",
                                  fontWeight: 600,
                                  color: "#000",
                                }}
                              >
                                Hobbies
                              </div>
                              <div
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(79,79,79,0.7)",
                                }}
                              >
                                A glimpse into my favorite pastimes.
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* DIVIDER */}
                        <div
                          style={{
                            marginTop: "18px",
                            height: "1px",
                            width: "100%",
                            background: "#D4D4D4",
                          }}
                        />

                        {/* ------- CONTENT ------- */}

                        <style>{`
 .pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 18px;
  border-radius: 50px;
  font-weight: 600;
  margin: 6px;
  font-size: 14px;
  white-space: nowrap;

  /* REAL GRADIENT BORDER */
  border: 1.9px solid transparent;
  background-image:
      linear-gradient(#FFFFFF, #FFFFFF), /* Inner background */
      linear-gradient(90deg, #F78C25, #FF3C3C); /* Border gradient */
  background-origin: border-box;
  background-clip: padding-box, border-box;

  /* GRADIENT TEXT */
  background-color: #fff; /* ensures inside stays white */
}

.pill span {
  background: linear-gradient(90deg, #F78C25, #FF3C3C);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.pill img {
  width: 18px;
  height: 18px;
  /* DO NOT apply gradient to icon */
  background: none !important;
  -webkit-background-clip: unset !important;
  -webkit-text-fill-color: unset !important;
}



  @media (max-width: 600px) {
    .pill { font-size: 13px; padding: 6px 14px; }
  }
`}</style>

                        {/* Loop through transformed hobbyCategories */}
                        {hobbyCategories.length > 0 ? (
                          hobbyCategories.map((cat, idx) => (
                            <div
                              key={idx}
                              style={{ marginTop: idx === 0 ? "20px" : "30px" }}
                            >
                              <div className="hobby-row-title">
                                Favorites {cat.title}
                              </div>

                              <div
                                style={{ display: "flex", flexWrap: "wrap" }}
                              >
                                {cat.hobbies.map((item, hIdx) => (
                                  <div className="pill" key={hIdx}>
                                    <img
                                      src={DoubleTick}
                                      width="16"
                                      height="16"
                                      alt=""
                                    />
                                    <span>{item}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))
                        ) : (
                          <p>No hobbies found.</p>
                        )}
                      </div>
                    )}

                    {/* =================== PREFERENCE TOP HEADER =================== */}
                    <div
                      style={{
                        width: "100%",
                        background:
                          "linear-gradient(180deg, #FFE6EC 0%, #E3F2FF 100%)",
                        borderRadius: "12px",
                        padding: "40px 20px",
                        textAlign: "center",
                        margin: "30px 0px",
                      }}
                    >
                      <div
                        className="match-pref-wrapper"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        {/* LEFT PERSON → You */}
                        <div
                          className="match-pref-person match-pref-left"
                          style={{
                            // display: "flex",
                            alignItems: "center",
                            // gap: "15px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "18px",
                              color: "#333",
                              fontFamily: "Montserrat, sans-serif",
                            }}
                          >
                            You
                          </div>

                          <div
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "50%",
                              padding: "3px",
                              background:
                                "linear-gradient(135deg, #FF9F43 0%, #FF3C3C 50%, #FF9F43 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                                overflow: "hidden",
                                position: "relative",
                                background: "#fff",
                              }}
                            >
                              {/* BLURRED BACKGROUND */}
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  backgroundImage: `url("${
                                    localStorage.getItem("profilePic") !==
                                    "null"
                                      ? localStorage.getItem("profilePic")
                                      : defaultImage
                                  }")`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  filter: "blur(12px)",
                                  transform: "scale(1.2)",
                                }}
                              />

                              {/* FOREGROUND IMAGE (CONTAIN) */}
                              <img
                                // src={
                                //   localStorage.getItem("profilePic") !== "null"
                                //     ? localStorage.getItem("profilePic")
                                //     : defaultImage
                                // }

                                src={
                                  profileData?.search?.owner_img || defaultImage
                                }
                                alt=""
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  margin: "auto",
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  borderRadius: "50%",
                                }}
                              />
                            </div>
                          </div>
                        </div>

                        {/* HEART ICON IN THE CENTER */}
                        <div
                          className="match-pref-heart"
                          style={{
                            flex: "0 0 auto",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={connectionHeartIcon}
                            alt="connection"
                            style={{
                              width: "min(260px, 40vw)",
                              height: "auto",
                              marginTop: "6px",
                            }}
                          />
                        </div>

                        {/* RIGHT PERSON → Preference */}
                        <div
                          className="match-pref-person match-pref-right"
                          style={{
                            // display: "flex",
                            alignItems: "center",
                            // gap: "15px",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 600,
                              fontSize: "18px",
                              color: "#333",
                              fontFamily: "Montserrat, sans-serif",
                            }}
                          >
                            Preference
                          </div>

                          <div
                            style={{
                              width: "90px",
                              height: "90px",
                              borderRadius: "50%",
                              padding: "3px",
                              background:
                                "linear-gradient(135deg, #FF9F43 0%, #FF3C3C 50%, #FF9F43 100%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "50%",
                                overflow: "hidden",
                                position: "relative",
                                background: "#fff",
                              }}
                            >
                              {/* BLURRED BACKGROUND */}
                              <div
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  backgroundImage: `url("${
                                    localStorage.getItem("profilePic") !==
                                    "null"
                                      ? localStorage.getItem("profilePic")
                                      : defaultImage
                                  }")`,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  filter: "blur(12px)",
                                  transform: "scale(1.2)",
                                }}
                              />

                              {/* FOREGROUND IMAGE (CONTAIN) */}
                              <img
                                src={
                                  profileData.search.user_info.photo ||
                                  defaultImage
                                }
                                alt=""
                                style={{
                                  position: "absolute",
                                  inset: 0,
                                  margin: "auto",
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  borderRadius: "50%",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* MATCH SCORE BOX */}
                      <div
                        style={{
                          marginTop: "22px",
                          display: "inline-block",
                          padding: "10px 22px",
                          borderRadius: "10px",
                          border: "1px solid #A8D8FF",
                          background: "#FFF",
                          fontSize: "15px",
                          fontWeight: 600,
                          color: "#333",
                          fontFamily: "Montserrat, sans-serif",
                        }}
                      >
                        {matchText}
                      </div>

                      {/* Responsive tweaks */}
                      <style>
                        {`
      @media (max-width: 768px) {
        .match-pref-wrapper {
          flex-direction: column;
          gap: 24px;
        }

        .match-pref-person {
          flex-direction: column !important;
        }

        .match-pref-heart img {
          width: 180px !important;
        }
      }
    `}
                      </style>
                    </div>

                    <div>
                      <div
                        style={{
                          marginTop: "25px",
                          fontSize: "20px",
                          fontWeight: 600,
                          color: "#000",
                        }}
                      >
                        Desired Partner Profile
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "rgba(79,79,79,0.7)",
                        }}
                      >
                        Here's a quick look at how well your details align with
                        preferences.
                      </div>
                    </div>

                    {/* ================= MATCH RESULT SECTIONS (NEW UI) ================= */}
                    {Object.entries(profileData.search.match_result  || {}).map(
                      ([sectionName, fields], index) => {
                        const sectionTitleMap = {
                          basic_details: "Basic Details",
                          education_occupation:
                            "Education and Profession Details",
                          native_location: "Native Location Preferences",
                          lifestyle_details: "Lifestyle Preferences",
                        };

                        const formattedSectionName =
                          sectionTitleMap[sectionName] ||
                          sectionName
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (c) => c.toUpperCase());

                        const isFirst = index === 0;

                        return (
                          <div
                            key={sectionName}
                            ref={isFirst ? desiredPartnerRef : null}
                            style={{
                              background: "#FFFFFF",
                              borderRadius: "10px",
                              padding: "24px",
                              margin: "30px 0px 0px 0px",
                              border: "1px solid #E6EEF6",
                              boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                            }}
                          >
                            <div
                              style={{
                                fontSize: "18px",
                                fontWeight: 700,
                                marginBottom: "20px",
                              }}
                            >
                              {formattedSectionName}

                              {/* -------- DIVIDER -------- */}
                              <div
                                style={{
                                  marginTop: "18px",
                                  height: "1px",
                                  width: "100%",
                                  background: "#D4D4D4",
                                }}
                              />
                            </div>

                            {/* <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "18px",
                              }}
                            >
                              {Object.entries(fields).map(([key, detail]) => {
                                const label = key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase());

                                const val = Array.isArray(detail.value)
                                  ? `${detail.value[0]} to ${detail.value[1]}`
                                  : detail.value;

                                return (
                                  // <div style={{ width: "fit-content" }}>
                                  <PreferenceBox
                                    key={key}
                                    title={label}
                                    value={val}
                                    match={detail.match}
                                  />
                                  // </div>
                                );
                              })}
                            </div> */}

                            <div style={{ marginTop: "10px" }}>
                              {Object.entries(fields).map(([key, detail]) => {
                                const label = key
                                  .replace(/_/g, " ")
                                  .replace(/\b\w/g, (c) => c.toUpperCase());

                                const val = Array.isArray(detail.value)
                                  ? `${detail.value[0]} to ${detail.value[1]}`
                                  : detail.value;

                                return (
                                  <PreferenceRow
                                    key={key}
                                    label={label}
                                    value={val}
                                    match={detail.match}
                                  />
                                );
                              })}
                            </div>
                          </div>
                        );
                      },
                    )}
                  </div>
                </div>
              </div>

              {/* ===== FLOATING ACTION BAR ===== */}
              <div
                className="floating-action-bar-wrapper"
                style={{
                  position: "fixed",
                  bottom: "24px",
                  left: stickyStyles.left,
                  width: stickyStyles.width,
                  zIndex: 999,
                  display: "flex",
                  justifyContent: "center",
                  padding: "0 18px", // Matches card side padding
                  opacity: showStickyActions && !openContactModal ? 1 : 0,
                  pointerEvents:
                    showStickyActions && !openContactModal ? "auto" : "none",
                  transform:
                    showStickyActions && !openContactModal
                      ? "translateY(0)"
                      : "translateY(40px)",
                  transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1.1)",
                }}
              >
                <div
                  className="sticky-action-inner"
                  style={{
                    display: "flex", // Forced from inline-flex to flex
                    width: "100%", // Match container width
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "16px 24px",
                    borderRadius: "10px",
                    // background: "rgba(255, 255, 255, 0.9)",
                    background:
                      "linear-gradient(180deg, rgba(255, 244, 235, 0.97), rgba(255, 238, 238, 0.97))",

                    backdropFilter: "blur(12px)",
                    boxShadow: "0px 15px 35px rgba(0, 0, 0, 0.14)",
                    border: "1px solid rgba(230, 238, 246, 0.8)",
                  }}
                >
                  <ActionButton
                    profileData={profileData}
                    onContactResult={handleContactResult}
                  />
                </div>
              </div>
            </div>

            <CommonContactModal
              open={openContactModal}
              onClose={() => setOpenContactModal(false)}
              profileData={{
                ...contactInfo,
                fallbackPhoto: defaultImage,
                user_info: { register_id: contactInfo?.username },
              }}
            />

            <ToastContainer />
          </div>
        </div>
      </div>
    </div>
  );
};
